export default {
  description: '{{name}} w {{city}}. Oficjalne menu. Zaoszczędź i zamów online.',
};
